import React from 'react';
import styled from 'styled-components';

import { COLORS, MQS, SPACINGS, FONT_FAMILY } from '../../../app/common/constants/styles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { ITermDetail } from '../rewardsClub.interface';

const TOTAL_ROWS = 5;

const TermPointsBase = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    padding: 12px;
    margin: 10px;
    border-radius: 8px;
    background-image: linear-gradient(to bottom, #f8f8f8, #f9f9f9 62%, white);
`;

const Container = styled.div`
    display: flex;
    @media (min-width: ${MQS.mq2Min}) {
        width: 100%;
    }
`;
const ExpiringAlert = styled.span`
    display: flex;
    font-size: 0.8125rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: ${COLORS.rakutenRed};
    @media (min-width: ${MQS.mq3Min}) {
        font-size: 1rem;
    }
`;

const TermPointsTitle = styled.h3`
    font-size: 1.25rem;
    margin-bottom: 10px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: ${COLORS.darkPurple};
    ${FONT_FAMILY.multipleBoldCss}
    font-weight: bold;
`;

const TermPointsWrapper = styled.li`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${COLORS.lightGrey};
    padding: ${SPACINGS.base * 2}px 0;
    &:last-child {
        border-bottom: none;
    }
`;

const Points = styled.div`
    display: flex;
    position: relative;
    font-size: 0.9375rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    color: ${COLORS.darkPurple};
    @media (min-width: ${MQS.mq3Min}) {
        font-size: 1.125rem;
    }
`;

const Date = styled.span`
    display: flex;
    position: relative;
    font-size: 0.8125rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: ${COLORS.darkPurple};

    @media (min-width: ${MQS.mq3Min}) {
        font-size: 1rem;
    }
`;
const TermPointsList = styled.ul`
    list-style: none;
    padding: 0;
`;

class TermPointsRow extends React.Component<{
    termDetailsEntry: ITermDetail;
    daysForExpiryAlert: number;
}> {
    render() {
        const {
            termDetailsEntry: { points, expiresInDays, formattedExpiryTime },
            daysForExpiryAlert,
        } = this.props;
        return (
            <TermPointsWrapper>
                <Points>
                    {points} {TranslationHelpers.getFormattedMessage('points.points')}
                </Points>

                {expiresInDays !== null &&
                expiresInDays !== undefined &&
                expiresInDays <= daysForExpiryAlert &&
                expiresInDays >= 2 ? (
                    <ExpiringAlert>
                        {expiresInDays + ' '}
                        {TranslationHelpers.getFormattedMessage('points.expiring.days')}
                    </ExpiringAlert>
                ) : null}
                {expiresInDays !== null &&
                expiresInDays !== undefined &&
                expiresInDays <= daysForExpiryAlert &&
                expiresInDays === 1 ? (
                    <ExpiringAlert>
                        {expiresInDays + ' '}
                        {TranslationHelpers.getFormattedMessage('points.expiring.day')}
                    </ExpiringAlert>
                ) : null}
                {expiresInDays !== null &&
                expiresInDays !== undefined &&
                expiresInDays <= daysForExpiryAlert &&
                expiresInDays === 0 ? (
                    <ExpiringAlert>
                        {TranslationHelpers.getFormattedMessage('points.expiring.today')}
                    </ExpiringAlert>
                ) : null}

                <Date>{formattedExpiryTime}</Date>
            </TermPointsWrapper>
        );
    }
}

class ExpiringPointsList extends React.Component<{
    termDetails: ITermDetail[];
    numberOfDaysForExpiryAlert: number;
}> {
    render() {
        const { termDetails, numberOfDaysForExpiryAlert } = this.props;
        return (
            <Container>
                <TermPointsBase>
                    <TermPointsTitle>
                        {TranslationHelpers.getFormattedMessage('points.expiring.title')}
                    </TermPointsTitle>
                    <TermPointsList>
                        {termDetails.slice(0, TOTAL_ROWS).map((termDetailsEntry, index) => (
                            <TermPointsRow
                                key={index}
                                termDetailsEntry={termDetailsEntry}
                                daysForExpiryAlert={numberOfDaysForExpiryAlert}
                            />
                        ))}
                    </TermPointsList>
                </TermPointsBase>
            </Container>
        );
    }
}

const NoTermDetailsFound = () => (
    <Container>
        <TermPointsBase>
            <TermPointsTitle>
                {TranslationHelpers.getFormattedMessage('points.expiring.title')}
            </TermPointsTitle>
            <TermPointsList>
                {TranslationHelpers.getFormattedMessage('points.no.expiring')}
            </TermPointsList>
        </TermPointsBase>
    </Container>
);

export default ExpiringPointsList;
export { NoTermDetailsFound };
